/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react'
import { LoginContext } from '../../Pages/User/LoginContext';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const { auth, setAuth, setInput, modal, setModal } = React.useContext(LoginContext);
  const navigate = useNavigate();
  function handleLogout(e) {
    e.preventDefault();
    setAuth({ user: '', auth: false, token: '' })
    setInput({ user: '', password: '' })
    localStorage.removeItem('user')
    setModal({ ...modal, pathname: '/login' })
    navigate('/login')
  }
  return (

    <div className="top-bar">
      <div className="-intro-x breadcrumb mr-auto hidden xl:flex"></div>
      <div className="intro-x relative mr-3 sm:mr-6"></div>
      <div className="intro-x dropdown w-8 h-8">
        <div
          className="dropdown-toggle w-8 h-8 rounded-full overflow-hidden shadow-lg image-fit zoom-in"
          role="button"
          aria-expanded="false"
        >
          <img alt="" src="/dist/images/profile-2.jpg" />
        </div>
        <div className="dropdown-menu w-56">
          <div className="dropdown-menu__content box bg-theme-26 dark:bg-dark-6 text-white">
            <div className="p-4 border-b border-theme-27 dark:border-dark-3">
              <div className="font-medium">Admin</div>
              <div className="text-xs text-theme-28 mt-0.5 dark:text-gray-600">
                {auth.user} Administrador
              </div>
            </div>
          </div>
        </div>
      </div>
      <button type='button' onClick={(e) => handleLogout(e)} className={'bg-dark-2 text-white text-center whitespace-nowrap block shadow-md p-2 mt-2'}>Logout</button>
    </div>
  );
}

export default Header
